export function getExponentialBackoffDelay(attempt, initialDelay, maxDelay = 60000) {
    if (attempt < 1) {
        throw Error('Attempt starting at 1');
    }
    return Math.min(Math.pow(2, (attempt - 1)) * initialDelay, maxDelay);
}
